"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSlider = void 0;
var _react_image_sliderModule = _interopRequireDefault(require("@albelli/arc-3/lib/react_image_slider.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = require("keen-slider/react");
var _propTypes = require("prop-types");
var _react2 = _interopRequireWildcard(require("react"));
var _ImageSliderThumbnail = require("./ImageSliderThumbnail");
var _SinglePicture = require("./SinglePicture");
var _SliderDots = require("./SliderDots");
var _SliderPicture = require("./SliderPicture");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultImageSizes = {
  large: {
    "1x": "d=700x700",
    "2x": "d=1400x1400"
  },
  medium: {
    "1x": "d=400x400",
    "2x": "d=800x800"
  }
};
const defaultThumbnailImageSizes = {
  small: {
    "1x": "d=72x72",
    "2x": "d=144x144"
  }
};
const defaultBreakpoints = {
  medium: "768px",
  large: "1280px"
};
const ImageSlider = _ref => {
  let {
    images,
    vertical = true,
    imageSizes = defaultImageSizes,
    thumbnailImageSizes = defaultThumbnailImageSizes,
    breakpoints = defaultBreakpoints
  } = _ref;
  const [currentSlide, setCurrentSlide] = (0, _react2.useState)(0);
  const [loaded, setLoaded] = (0, _react2.useState)(false);
  const [sliderRef, instanceRef] = (0, _react.useKeenSlider)({
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    }
  });
  const pictureInitialSizing = (imageSizes.small || imageSizes.medium || imageSizes.large)["1x"];
  const pictureInitialSize = (0, _react2.useMemo)(() => ({
    height: +pictureInitialSizing.replace(/d=(\d+)x\d+/, (_, height) => height),
    width: +pictureInitialSizing.replace(/d=\d+x(\d+)/, (_, width) => width)
  }), [pictureInitialSizing]);
  if (images.length === 1) {
    const [image] = images;
    return /*#__PURE__*/_react2.default.createElement(_SinglePicture.SinglePicture, {
      src: image.src,
      alt: image.alt,
      width: pictureInitialSize.width,
      imageSizes: imageSizes,
      breakpoints: breakpoints,
      dataCy: "Slider-MainPicture-0"
    });
  }
  return /*#__PURE__*/_react2.default.createElement("div", {
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider"], _react_image_sliderModule.default["--square"], vertical && _react_image_sliderModule.default["--vertical"])
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__main-wrapper"])
  }, /*#__PURE__*/_react2.default.createElement("div", {
    ref: sliderRef,
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__main-wrapper__inner"], "keen-slider")
  }, images.map((_ref2, idx) => {
    let {
      src,
      alt
    } = _ref2;
    return /*#__PURE__*/_react2.default.createElement(_SliderPicture.SliderPicture, {
      key: idx,
      src: src,
      alt: alt,
      height: pictureInitialSize.height,
      width: pictureInitialSize.width,
      imageSizes: imageSizes,
      breakpoints: breakpoints,
      imageIndex: idx,
      dataCy: "Slider-MainPicture-".concat(idx)
    });
  })), loaded && instanceRef.current && /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, currentSlide !== 0 && /*#__PURE__*/_react2.default.createElement("button", {
    onClick: e => {
      var _instanceRef$current;
      return e.stopPropagation() || ((_instanceRef$current = instanceRef.current) === null || _instanceRef$current === void 0 ? void 0 : _instanceRef$current.prev());
    },
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__main-wrapper__arrow"], _react_image_sliderModule.default["--left"])
  }, " "), currentSlide !== images.length - 1 && /*#__PURE__*/_react2.default.createElement("button", {
    onClick: e => {
      var _instanceRef$current2;
      return e.stopPropagation() || ((_instanceRef$current2 = instanceRef.current) === null || _instanceRef$current2 === void 0 ? void 0 : _instanceRef$current2.next());
    },
    className: (0, _classnames.default)(_react_image_sliderModule.default["arc3-react-image-slider__main-wrapper__arrow"], _react_image_sliderModule.default["--right"])
  }, " "), /*#__PURE__*/_react2.default.createElement(_SliderDots.SliderDots, {
    images: images,
    currentSlide: currentSlide,
    onClick: idx => instanceRef.current.moveToIdx(idx)
  }))), loaded && instanceRef.current && /*#__PURE__*/_react2.default.createElement(_ImageSliderThumbnail.ImageSliderThumbnail, {
    sliderRef: sliderRef,
    instanceRef: instanceRef,
    images: images,
    imageSizes: thumbnailImageSizes,
    vertical: vertical
  }));
};
exports.ImageSlider = ImageSlider;
ImageSlider.propTypes = {
  /** Array of objects like { src: 'pathToImage', alt: 'alt text' } */
  images: _propTypes.PropTypes.array,
  /** Should thumbnail be vertical */
  vertical: _propTypes.PropTypes.bool,
  /** optional, sizes object for media breakpoints uploads */
  imageSizes: _propTypes.PropTypes.object,
  /** optional, sizes object for media breakpoints uploads */
  thumbnailImageSizes: _propTypes.PropTypes.object,
  /** optional, breakpoints on which to apply imageSizes */
  breakpoints: _propTypes.PropTypes.object
};